import { render, staticRenderFns } from "./ExpertScene.vue?vue&type=template&id=6ec837c6&scoped=true"
import script from "./ExpertScene.vue?vue&type=script&lang=js"
export * from "./ExpertScene.vue?vue&type=script&lang=js"
import style0 from "./ExpertScene.vue?vue&type=style&index=0&id=6ec837c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec837c6",
  null
  
)

export default component.exports